// extracted by mini-css-extract-plugin
export default {"banner":"BannerCategories_banner__daKgs","item":"BannerCategories_item__mGFaS"};